import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'utils/axios';

export const downloadInvoice = createAsyncThunk('download/invoice', async (payload, thunkAPI) => {
  const { transactionKey, orderKey } = payload;
  // console.log(payload);

  try {
    const response = await axiosInstance.get(`/admin/orders/${transactionKey}/invoice`, {
      responseType: 'blob',
    });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const a = document.createElement('a');
    a.href = url;
    a.download = `invoice-${orderKey}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.data?.message || error.message);
  }
});
